__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@onvio/staff";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "13.4.0", () => (__webpack_require__.e(3308).then(() => (() => (__webpack_require__(63308))))));
			register("@angular/common/http", "13.4.0", () => (__webpack_require__.e(4018).then(() => (() => (__webpack_require__(54018))))));
			register("@angular/common", "13.4.0", () => (__webpack_require__.e(4608).then(() => (() => (__webpack_require__(64608))))));
			register("@angular/compiler", "13.4.0", () => (__webpack_require__.e(5974).then(() => (() => (__webpack_require__(45974))))));
			register("@angular/core", "13.4.0", () => (__webpack_require__.e(2252).then(() => (() => (__webpack_require__(2252))))));
			register("@angular/forms", "13.4.0", () => (__webpack_require__.e(8174).then(() => (() => (__webpack_require__(98174))))));
			register("@angular/platform-browser-dynamic", "13.4.0", () => (__webpack_require__.e(315).then(() => (() => (__webpack_require__(70315))))));
			register("@angular/platform-browser", "13.4.0", () => (__webpack_require__.e(7562).then(() => (() => (__webpack_require__(67562))))));
			register("@angular/router", "13.4.0", () => (__webpack_require__.e(1704).then(() => (() => (__webpack_require__(1704))))));
			register("@bento/bento-ng", "13.0.0", () => (__webpack_require__.e(8954).then(() => (() => (__webpack_require__(68954))))));
			register("@bento/bfm-ng", "5.0.0", () => (__webpack_require__.e(1378).then(() => (() => (__webpack_require__(51378))))));
			register("@blue/helpers", "2.0.0", () => (__webpack_require__.e(8732).then(() => (() => (__webpack_require__(8732))))));
			register("@blue/pendo", "6.0.2", () => (__webpack_require__.e(1140).then(() => (() => (__webpack_require__(678))))));
			register("@blue/profile-services", "1.0.0", () => (__webpack_require__.e(2688).then(() => (() => (__webpack_require__(22688))))));
			register("@blue/security-services", "3.0.0", () => (__webpack_require__.e(2789).then(() => (() => (__webpack_require__(72789))))));
			register("@blue/services/environment", "7.6.14", () => (__webpack_require__.e(4369).then(() => (() => (__webpack_require__(94369))))));
			register("@blue/services/session", "7.6.14", () => (__webpack_require__.e(781).then(() => (() => (__webpack_require__(55923))))));
			register("@blue/translation", "1.0.0", () => (__webpack_require__.e(5709).then(() => (() => (__webpack_require__(15709))))));
			register("@blue/web-storage", "2.0.0", () => (__webpack_require__.e(4035).then(() => (() => (__webpack_require__(64035))))));
			register("@bm-core/datadog", "2.1.1", () => (__webpack_require__.e(6935).then(() => (() => (__webpack_require__(96935))))));
			register("@bm-core/mfe-loader", "1.0.4", () => (__webpack_require__.e(7597).then(() => (() => (__webpack_require__(87597))))));
			register("@fecoe/fetch", "1.1.2", () => (__webpack_require__.e(4559).then(() => (() => (__webpack_require__(7766))))));
			register("@grapecity/wijmo.angular2.grid.detail", "5.20251.40", () => (__webpack_require__.e(247).then(() => (() => (__webpack_require__(30247))))));
			register("@grapecity/wijmo.angular2.grid.filter", "5.20251.40", () => (__webpack_require__.e(8324).then(() => (() => (__webpack_require__(68324))))));
			register("@grapecity/wijmo.angular2.grid.grouppanel", "5.20251.40", () => (__webpack_require__.e(4759).then(() => (() => (__webpack_require__(24759))))));
			register("@grapecity/wijmo.angular2.grid", "5.20251.40", () => (__webpack_require__.e(5864).then(() => (() => (__webpack_require__(25864))))));
			register("@grapecity/wijmo.angular2.input", "5.20251.40", () => (__webpack_require__.e(7207).then(() => (() => (__webpack_require__(7207))))));
			register("@grapecity/wijmo.grid.detail", "5.20251.40", () => (() => (__webpack_require__(81724))), 1);
			register("@grapecity/wijmo.grid.filter", "5.20251.40", () => (() => (__webpack_require__(73883))), 1);
			register("@grapecity/wijmo.grid.grouppanel", "5.20251.40", () => (() => (__webpack_require__(66356))), 1);
			register("@grapecity/wijmo.grid.xlsx", "5.20251.40", () => (() => (__webpack_require__(9250))), 1);
			register("@grapecity/wijmo.grid", "5.20251.40", () => (() => (__webpack_require__(58292))), 1);
			register("@grapecity/wijmo.input", "5.20251.40", () => (() => (__webpack_require__(49842))), 1);
			register("@grapecity/wijmo.xlsx", "5.20251.40", () => (() => (__webpack_require__(85369))), 1);
			register("@grapecity/wijmo", "5.20251.40", () => (() => (__webpack_require__(86893))), 1);
			register("@ng-bootstrap/ng-bootstrap", "9.1.3", () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(18305))))));
			register("@ngx-translate/core", "12.1.2", () => (__webpack_require__.e(6828).then(() => (() => (__webpack_require__(1749))))));
			register("@ngx-translate/http-loader", "4.0.0", () => (__webpack_require__.e(1840).then(() => (() => (__webpack_require__(1840))))));
			register("@onvio-design/components", "0.7.0", () => (__webpack_require__.e(8622).then(() => (() => (__webpack_require__(48622))))));
			register("@tr/app-information", "1.0.3", () => (__webpack_require__.e(8307).then(() => (() => (__webpack_require__(18307))))));
			register("date-fns", "2.28.0", () => (__webpack_require__.e(2319).then(() => (() => (__webpack_require__(2319))))));
			register("rxjs/operators", "6.6.7", () => (__webpack_require__.e(3048).then(() => (() => (__webpack_require__(83048))))));
			register("rxjs", "6.6.7", () => (__webpack_require__.e(3519).then(() => (() => (__webpack_require__(43519))))));
			register("tslib", "1.14.1", () => (__webpack_require__.e(7490).then(() => (() => (__webpack_require__(87490))))));
			register("tslib", "2.3.1", () => (__webpack_require__.e(3074).then(() => (() => (__webpack_require__(3074))))));
			register("tslib", "2.4.0", () => (__webpack_require__.e(5296).then(() => (() => (__webpack_require__(35296))))));
			register("tslib", "2.6.1", () => (__webpack_require__.e(1950).then(() => (() => (__webpack_require__(61950))))));
			register("tslib", "2.6.2", () => (__webpack_require__.e(4237).then(() => (() => (__webpack_require__(44237))))));
			register("tslib", "2.6.3", () => (__webpack_require__.e(6386).then(() => (() => (__webpack_require__(16386))))));
			initExternal(43569);
			initExternal(48059);
			initExternal(61726);
			initExternal(25968);
			initExternal(59679);
			initExternal(63283);
			initExternal(74278);
			initExternal(65132);
			initExternal(66917);
			initExternal(69534);
			initExternal(25132);
			initExternal(23048);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};